export const GET_COURSES = "GET_COURSES"